"use strict";

var AbstractStore = require("./AbstractStore");

var SuggestedDonationHelper = require("../commonComponents/SuggestedDonationHelper");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	productCode: null,
	isDesignMode: false,
	isInPledgeStatementSession: false,
	isShippable: false,
	selectedQuantity: null,
	selectedQuantities: {},
	selectedSuggestedDonation: null,
	selectedSuggestedDonations: {},
	defaultSuggestedDonation: null, // this is the default value from the model.
	defaultSuggestedDonations: {}, // these are the default values from the models.
	warehouse: null,
	wizardPledgeStatementEntry: {},
	wizardShoppingCartDisplayMessages: {}
};

var ProductStore = class extends AbstractStore {
	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}

	getSelectedQuantity(context, tangibleCode) {
		if (context) {
			if (state.selectedQuantities[context]) {
				return state.selectedQuantities[context][tangibleCode];
			} else {
				return null;
			}
		} else {
			return state.selectedQuantity;
		}
	}

	getOrderInformation(cartDataOptions) {
		cartDataOptions = cartDataOptions || {};
		var { context, tangibleCode } = cartDataOptions;

		return {
			product: tangibleCode || state.productCode,
			isShippable: state.isShippable,
			quantity: this.getSelectedQuantity(context, tangibleCode) || "1",
			suggestedDonation: this.getSuggestedDonation(context, tangibleCode),
			warehouse: state.warehouse
		};
	}

	getDefaultSuggestedDonation(context, productCode)
	{
		if (context) {
			if (state.defaultSuggestedDonations[context]) {
				return state.defaultSuggestedDonations[context][productCode];
			}
		} else {
			return state.defaultSuggestedDonation;
		}
	}

	getSuggestedDonation(context, productCode) {
		if (context && !productCode) {
			return;
		}

		if (context) {
			if (state.selectedSuggestedDonations[context]) {
				return state.selectedSuggestedDonations[context][productCode];
			}
		} else {
			return state.selectedSuggestedDonation;
		}
	}

	validateSuggestedAmount(amount, context, productCode) {
		amount = amount || this.getSuggestedDonation(context, productCode);
		var defaultSuggestedAmount = this.getDefaultSuggestedDonation(context,  productCode);

		return SuggestedDonationHelper.validateAmount(
			amount,
			defaultSuggestedAmount);
	}
};
ProductStore = new ProductStore();

ProductStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case Constants.PRODUCT_INITIALIZE:
			state.isDesignMode = action.isDesignMode;
			state.isInPledgeStatementSession = action.isInPledgeStatementSession;
			state.isShippable = action.isShippable;
			state.productCode = action.productCode;
			state.defaultSuggestedDonation = action.defaultSuggestedDonation;
			state.warehouse = action.warehouse;
			state.wizardPledgeStatementEntry = action.wizardPledgeStatementEntry;
			state.wizardShoppingCartDisplayMessages = action.wizardShoppingCartDisplayMessages;

			if (state.productCode && state.defaultSuggestedDonation >= 0) {
				SuggestedDonationHelper.updateSuggestedDonationComponent(
					action.defaultSuggestedDonation,
					null,
					state.productCode);
			}

			return true; // Don't emit change

		case Constants.PRODUCT_INITIALIZE_SUGGESTED_DONATION:
			// This should behave the same as the PRODUCT_SET_SUGGESTED_DONATION except we are not
			// validating the amount as this is the first time we're setting it.
			var initialAmount = (+action.amount).toFixed(2);
			if (action.context) {
				if (!state.selectedSuggestedDonations[action.context]) {
					state.selectedSuggestedDonations[action.context] = {};
				}

				if (!state.defaultSuggestedDonations[action.context]) {
					state.defaultSuggestedDonations[action.context] = {};
				}

				state.selectedSuggestedDonations[action.context][action.productCode] = initialAmount;
				state.defaultSuggestedDonations[action.context][action.productCode] = initialAmount;

			} else {
				state.selectedSuggestedDonation = initialAmount;
				state.defaultSuggestedDonation = initialAmount;
			}

			SuggestedDonationHelper.updateSuggestedDonationComponent(
				initialAmount,
				action.context,
				action.productCode);
			break;

		case Constants.PRODUCT_SET_QUANTITY:
			if (action.context) {
				if (!state.selectedQuantities[action.context]) {
					state.selectedQuantities[action.context] = {};
				}
				state.selectedQuantities[action.context][action.tangibleCode] = action.selectedQuantity;
			} else {
				state.selectedQuantity = action.selectedQuantity;
			}
			break;

		case Constants.PRODUCT_SET_SUGGESTED_DONATION:
			var { amount, context, productCode } = action;

			var suggestedDonationSetIsValid = ProductStore.validateSuggestedAmount(
				+amount,
				context,
				productCode);

			var newAmount = (+amount).toFixed(2);
			if (context) {
				if (!state.selectedSuggestedDonations[context]) {
					state.selectedSuggestedDonations[context] = {};
				}

				state.selectedSuggestedDonations[context][productCode] = newAmount;
			} else {
				state.selectedSuggestedDonation = newAmount;
			}

			// Because both values are string, we cannot use coersion to check equality between 100 and 100.00.
			// Casting as a number will drop any .00 values so this functions essentially the same way.
			if (+amount !== +newAmount) {
				SuggestedDonationHelper.updateSuggestedDonationComponent(newAmount, context, productCode);
			}

			if (suggestedDonationSetIsValid) {
				SuggestedDonationHelper.hideInvalidSuggestedDonationMessage(context,  productCode);
			} else {
				SuggestedDonationHelper.showInvalidSuggestedDonationMessage(context, productCode);
			}

			break;

		default:
			// no op
			return true;
	}

	ProductStore.emitChange();
	return true;
});

module.exports = ProductStore;



// WEBPACK FOOTER //
// ./Javascript/stores/ProductStore.jsx